import i18n from 'i18next';
import ICU from 'i18next-icu';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import AtlasSdk from '@atlas/sdk';

import app from '../../public/locales/en-US/app.json';
import global from '../../public/locales/en-US/global.json';
import metadata from '../../public/locales/en-US/metadata.json';
import dateNumber from '../../public/locales/en-US/dateNumber.json';

// types
interface II18nSwitchLanguageParams {
  language: string;
}
export type KeysType<T extends keyof typeof defaultResource = keyof typeof defaultResource> = {
  [P in T]: keyof typeof defaultResource[P];
}[T];

// variable
export const DEFAULT_LANGUAGE = 'en-US';
export const defaultNS = 'app';
export const defaultResource = {
  app,
  global,
  metadata,
  dateNumber,
} as const;

// const resources = { [DEFAULT_LANGUAGE]: defaultResource };

export default async function configI18n(lng: string) {
  const { resourcesTemplateUrl } = await AtlasSdk.i18n.getConfig();
  await i18n
    .use(ICU)
    .use(Backend)
    .use(initReactI18next)
    .init({
      lng,
      ns: Object.keys(defaultResource),
      defaultNS,
      fallbackLng: DEFAULT_LANGUAGE,
      backend: {
        crossDomain: true,
        loadPath: resourcesTemplateUrl,
      },
      load: 'currentOnly',
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      react: {
        useSuspense: false,
      },
      // resources,
      keySeparator: false,
    });

  return {
    changeLanguage: ({ language }: II18nSwitchLanguageParams) => window.location.reload(),
  };
}
